module.exports = __webpack_public_path__ + "static/img/com_dividing_star@2x.85a687ec.png";